import React from "react";

interface KPIRowProps {
  children: React.ReactNode;
}

const KPIRow: React.FC<KPIRowProps> = ({ children }) => {
  return (
    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" as const, width: "100%" }}>
      {children}
    </div>
  );
};

export default KPIRow;
